import React from 'react';
import { Modal, Paper } from '@mui/material';
import EditOperationObjectiveLayout from '../layouts/EditOperationObjectiveLayout';
import {OperationObjective} from "../../../classes/OperationObjective";
import {Operation} from "../../../classes/Operation";

function NewOperationObjectiveModal(props: {
    isOpen: boolean,
    operationData: Operation,
    onClose: Function,
    onSubmit: Function,
    onNetworkError: Function
}) {

    const newObjective = new OperationObjective()
    newObjective.operationId = props.operationData.id!

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditOperationObjectiveLayout
                    title="Create Objective"
                    initInfo={newObjective}
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default NewOperationObjectiveModal;